import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** EB-1 — CHAR. Le Bastion dont on N'A PAS le choix.
 *
 *  ── Ce qu'il enseigne, et en quoi il diffère du Bastion ──
 *  Le Bastion POSE un choix : ses tourelles sont optionnelles, on peut foncer
 *  au noyau et encaisser leur feu. Le Char le RETIRE. Son noyau est verrouillé
 *  par ses parties (`shieldedByParts`) : tant qu'un canon vit, le châssis est
 *  intouchable. On ne débat plus de « faut-il désarmer » — il FAUT, la seule
 *  question restante est l'ORDRE.
 *
 *  C'est la marche que le Bastion n'apprend pas et que les boss à parties
 *  scellées exigent : quand désarmer n'est plus une économie mais une condition,
 *  le joueur cesse de raisonner en dégâts et se met à raisonner en priorités.
 *
 *  ── Pourquoi deux canons de NATURES différentes ──
 *  Gauche : un canon VISÉ, qui suit le joueur et lui interdit de se poser.
 *  Droit : un ÉVENTAIL statique, qui condamne une zone quoi qu'il fasse.
 *  L'ordre a donc une conséquence lisible : abattre le visé d'abord, c'est
 *  gagner le droit de s'immobiliser pour soigner sa visée sur le reste ; abattre
 *  l'éventail d'abord, c'est rouvrir un pan de terrain. Deux canons identiques
 *  auraient imposé un ordre sans en faire un choix.
 *
 *  ── Pourquoi il se poste au lieu de descendre ──
 *  Contrairement au Bastion qui traverse en ligne droite, le Char prend POSITION
 *  à mi-hauteur et n'en bouge plus qu'en tanguant. Un verrou que l'on doit forcer
 *  ne doit pas s'échapper par le bas pendant qu'on le force : il resterait des
 *  canons vivants à l'écran et la leçon — « finis ce que tu commences » — se
 *  dissoudrait dans le hors-champ. Posté, il oblige à conclure. */
export default defineEnemy({
  id: 'char',
  rank: Rank.Heavy,
  hp: 500,
  visualRadius: 48,
  score: 900,
  telegraph: 1.1,
  drops: 4,
  // Il avance jusqu'à sa station puis tangue lentement : un poste de tir mobile,
  // pas un voltigeur. L'oscillation suffit à ce que la zone sûre se déplace, sans
  // jamais le laisser fuir la confrontation.
  motion: { kind: Motion.Hover, speed: 200, amplitude: 42, frequency: 0.4, holdY: 300 },
  // ⚠️ Noyau VERROUILLÉ : intouchable tant qu'un canon survit. C'est tout ce qui
  // le sépare du Bastion — même silhouette, obligation au lieu de choix.
  shieldedByParts: true,
  parts: [
    { enemy: 'char-tourelle-g', offX: -58, offY: 6 },
    { enemy: 'char-tourelle-d', offX: 58, offY: 6 },
  ],
  emitter: {
    // Le canon de caisse : lent et large, une pression de fond pendant qu'on
    // s'occupe des tourelles. L'essentiel de la menace est dans les canons, sinon
    // les abattre ne se ressentirait pas.
    pattern: Pattern.Fan,
    every: 3.4,
    count: 5,
    spreadDeg: 110,
    speed: 300,
    firstDelay: 2.4,
    family: Fam.EnemyRed,
  },
});
